exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page-container[data-v-7c8b0352] {\n  padding-inline: 18px;\n  padding-block: 8px 16px;\n  position: relative;\n  -ms-flex: 1;\n      flex: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  row-gap: 16px;\n}\n.page-container > .title[data-v-7c8b0352] {\n    font-weight: 600;\n    font-size: 28px;\n}\n.history-list[data-v-7c8b0352] {\n  display: -ms-grid;\n  display: grid;\n  gap: 8px;\n  overflow-y: auto;\n  -ms-flex: 1;\n      flex: 1;\n  margin-bottom: 15px;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n}\n.buttons[data-v-7c8b0352] {\n  margin-top: auto;\n  gap: 10px;\n}\n.no-content[data-v-7c8b0352] {\n  color: #8f8e8e;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7c8b0352","scoped":true,"hasInlineConfig":false}!./~/sass-loader?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/referral-program/recommend-friend-history.vue
// module id = 635
// module chunks = 0